import { createSlice } from '@reduxjs/toolkit';

// Help → Ask AI: the user guide's chat in a side panel (GlobalHelpChat).
export const helpChatSlice = createSlice({
  name: 'helpChat',
  initialState: {
    isOpen: false,
  },
  reducers: {
    openHelpChat: state => {
      state.isOpen = true;
    },
    closeHelpChat: state => {
      state.isOpen = false;
    },
  },
});

export const { openHelpChat, closeHelpChat } = helpChatSlice.actions;

export default helpChatSlice.reducer;
